
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import FloatPanel, { POSITION_SET } from '@/components/molecules/FloatPanel.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import { RegisterType } from '@/const/manage/RegisterType'

/**
 * 仮生徒編集フロートメニュー
 */
@Component({
  components: {
    ImageBase,
    ButtonBase,
    FloatPanel,
    PanelFrame,
  },
})
export default class MenuEditTemporaryStudent extends Vue {
  /** フロートメニュー部 */
  @Ref()
  floatPanel!: FloatPanel

  /** 塾権限での使用か否か(機能制限用) */
  @Prop()
  private isAcademy!: boolean

  /** 削除ボタン押下時のイベント */
  @Prop()
  private eventClickDeleteButton!: (userId: number) => void

  /** ユーザデータ編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditUserDataButton!: (userId: number) => void

  /** パスワード編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditPasswordButton!: (userId: number) => void

  /** 高さ指定:高 */
  private readonly HIGH_HEIGHT = 180

  /** 高さ指定:低 */
  private readonly LOW_HEIGHT = 70

  /** 操作対象のユーザID */
  private userId = 0

  /** 登録種別 */
  private registerType: number | null = null

  /** クローズ時の処理 */
  private eventClosed: (() => void) | undefined = undefined

  /**
   * 高さ指定
   *
   * @returns 要素数(機能数)に合わせた高さを指定
   */
  private get height(): number {
    // 塾権限での使用時
    if (this.isAcademy) {
      return this.HIGH_HEIGHT
    }

    // 教室権限での使用時
    return this.LOW_HEIGHT
  }

  /**
   * ボタンのDisabled制御
   *
   * @returns 登録種別が外部連携ならtrue
   */
  private get buttonDisabled(): boolean {
    return this.registerType === RegisterType.EXTERNAL
  }

  /**
   * 表示
   *
   * @param target 表示位置の基準にするDOM要素
   * @param userId 操作対象ユーザID
   * @param registerType 登録種別
   * @param parentElement オプション情報表示エリアの基準となる親DOM要素
   */
  public async show(
    target: HTMLElement,
    userId: number,
    registerType: number | null,
    parentElement?: HTMLElement
  ): Promise<void> {
    this.userId = userId
    this.registerType = registerType
    await this.floatPanel.show(target, POSITION_SET.LEFT_DOWN, parentElement)
  }

  /**
   * 削除ボタン押下時処理
   */
  private eventDelete(): void {
    this.floatPanel.close()
    this.eventClickDeleteButton(this.userId)
  }

  /**
   * 編集ボタン押下時処理
   */
  private eventEditStudent(): void {
    this.floatPanel.close()
    this.eventClickEditUserDataButton(this.userId)
  }

  /**
   * パスワード変更ボタン押下時処理
   */
  private eventEditPassword(): void {
    this.floatPanel.close()
    this.eventClickEditPasswordButton(this.userId)
  }

  /**
   * クローズ時処理
   */
  private closeEvent(): void {
    // 設定されている場合のみ実行
    if (this.eventClosed) {
      this.eventClosed()
    }
  }
}
